import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { TableViabilidade } from "./TabelaViabilidade";

const AccordionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 5px;
  background-color: white;
`;

const AccordionNameSection = styled.span`
  display: flex;
  align-items: center;
`;

const AccordionTitle = styled.span`
  color: #212322;
  padding-left: 1em;
  font-weight: 600;
  font-size: 16px;
`;

const textDescription = `Segue abaixo o quadro comparativo de viabilidade dos últimos meses, elaborado para identificar a melhor opção tarifária e o tipo de energia mais adequado à unidade consumidora. Para informações mais detalhadas faça o download do PDF.`;

interface ViabilidadeAccordionProps {
  profiles: any[] | null;
}

export function ViabilidadeAccordion({ profiles }: ViabilidadeAccordionProps) {
  const resumeViabilities = profiles
    ? profiles
        .map((profile) =>
          typeof profile.additional_data === "string"
            ? JSON.parse(profile.additional_data)
            : profile.additional_data
        )
        .filter((data) => data !== undefined && data !== null)
    : [];

  const handleDownloadAllPDFs = async () => {
    if (!profiles || !Array.isArray(profiles)) return;

    const zip = new JSZip();
    for (let profileIndex = 0; profileIndex < profiles.length; profileIndex++) {
      const profile = profiles[profileIndex];
      if (!profile.uploads || !Array.isArray(profile.uploads)) continue;

      const pdfFile = profile.uploads.find(
        (file: any) => file.type === "VIABILIDADE_THS"
      );

      if (!pdfFile || !pdfFile.url) continue;

      try {
        const response = await fetch(pdfFile.url);
        const blob = await response.blob();

        const fileName = pdfFile.name || `viabilidade_${profileIndex + 1}.pdf`;
        zip.file(fileName, blob);
      } catch (error) {
        console.error(
          `Erro ao baixar o PDF do perfil ${profileIndex + 1}:`,
          error
        );
      }
    }
    const zipFile = await zip.generateAsync({ type: "blob" });
    saveAs(zipFile, "Relatorio de viabilidade THS.zip");
  };

  if (!resumeViabilities || resumeViabilities.length === 0) return null;

  return (
    <Accordion>
      <AccordionContainer>
        <Card style={{ width: "100%" }}>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            flush="true"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
              backgroundColor: "white",
              borderRadius: "5px 5px 5px 5px",
              paddingLeft: "2em",
              border: "1px solid #0072ce",
              minHeight: "70px",
            }}
          >
            <AccordionNameSection>
              <AccordionTitle>
                Comparação de viabilidade para cada THS e tipo de energia
              </AccordionTitle>
            </AccordionNameSection>
            <FontAwesomeIcon
              icon={faChevronDown}
              size="lg"
              style={{ marginRight: "1.2em" }}
            />
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <div style={{ margin: "32px 0 16px 0" }}>
                <div className="tableTitle d-flex align-items-center mb-3">
                  <div style={{ flex: 1 }} />
                  <span
                    className="clientDashboard-text fw-bold text-center"
                    style={{ flex: 3 }}
                  >
                    Comparação de viabilidade para cada THS e tipo de energia
                  </span>
                  <div
                    style={{ flex: 1 }}
                    className="d-flex justify-content-end"
                  >
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={handleDownloadAllPDFs}
                    >
                      Baixar PDF
                    </button>
                  </div>
                </div>
                {textDescription.split("\n").map((paragraph, idx) => (
                  <p key={idx} className="text-muted small">
                    {paragraph}
                  </p>
                ))}
                <TableViabilidade resumeViabilities={resumeViabilities} />
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </AccordionContainer>
    </Accordion>
  );
}
